import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M18 0H2C.9 0 0 .9 0 2v16c0 1.1.9 2 2 2l8.013.013L18 20c.289 0 .562-.065.811-.177C19.509 19.51 20 18.811 20 18V2c0-1.1-.9-2-2-2zm1 18c0 .538-.429.971-.961.992-.014.001-.025.008-.039.008H2c-.551 0-1-.449-1-1v-5.573l4.961-4.961 7.226 7.774 2.787-2.787L19 15.709V18zm-3-6.987L13.213 13.8 5.987 6.026 1 11.013V2c0-.551.449-1 1-1h16c.551 0 1 .449 1 1v12.241l-3-3.228z',
    'M14.5 3C13.119 3 12 4.119 12 5.5S13.119 8 14.5 8 17 6.881 17 5.5 15.881 3 14.5 3zm0 4c-.827 0-1.5-.673-1.5-1.5S13.673 4 14.5 4s1.5.673 1.5 1.5S15.327 7 14.5 7z',
  ],
  height: 20,
  width: 20,
});
